import { useTheme } from '@mui/material/styles';
import MuiRadio, { RadioProps } from '@mui/material/Radio';

interface IProps extends RadioProps {
    label?: string;
    className?: string;
    error?: boolean;
    testId?: string;
    onChange?: () => void;
}

export const SimpleRadio = ({ testId = 'base-simple-radio', className, label, error, onChange, ...props }: IProps) => {
    const theme = useTheme();

    return (
        <div data-testid={`${testId}-wrapper`} className={`flex items-center gap-1 lg:gap-2 ${className}`} onClick={onChange}>
            <MuiRadio
                data-testid={testId}
                {...props}
                sx={{
                    '& .MuiSvgIcon-root': {
                        fill: error ? '#FF0707' : '#02836F'
                    },
                    [theme.breakpoints.down('lg')]: {
                        width: '22px',
                        height: '22px'
                    },
                    [theme.breakpoints.up('lg')]: {
                        width: '30px',
                        height: '30px'
                    },
                    ...props.sx
                }}
            />
            {label && <span data-testid={`${testId}-label`} className="cursor-pointer font-atkinsonHyperlegible">{label}</span>}
        </div>
    );
};
